<style>
.ivu-vueTime {
  width: 100%;
  height: 100%;
}

.ivu-vueTime-div {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 0;
}

.ivu-date-picker {
  height: 100%;
  width: 100%;
}

.ivu-date-picker-rel {
  height: 100%;
}

.ivu-input-wrapper {
  height: 100%;
}

/* .ivu-input-wrapper-small .ivu-input-icon{
        height:100%;
        display:flex;
        align-items:center;
        justify-content:center;
    }
    .ivu-input-small{
        height:100%;
        line-height: 100%;
    } */
</style>

<template>
  <div class="ivu-vueTime-div timeId" v-if="isShow" :style="timeStyle">
    <!-- 时间日期 -->
    <DatePicker
      type="datetime"
      v-model="times"
      placeholder="Select time"
      :disabled="isEnable"
      v-if="isShowTime == 0"
    >
    </DatePicker>
    <!-- 日期 -->
    <DatePicker
      type="date"
      placeholder="Select date"
      :disabled="isEnable"
      v-model="times"
      :transfer="true"
      v-else-if="isShowTime == -1"
      :options="futureTime"
    ></DatePicker>
    <!-- 时间 -->
    <TimePicker
      type="time"
      placeholder="Select time"
      :disabled="isEnable"
      v-model="times"
      :transfer="true"
      v-else-if="isShowTime == 1"
    ></TimePicker>
    <!-- {{ time }} -->
    <div v-if="isEnable" :style="enableStyle"></div>
  </div>
</template>
<style>
.timeId .ivu-input {
  height: 100%;
}

/*修改日历图标位置*/
.timeId .ivu-input-suffix .ivu-icon-ios-calendar-outline {
  line-height: 0;
  position: absolute;
  top: 50%;
}

/*修改悬浮的关闭*/
.timeId .ivu-input-suffix .ivu-icon-ios-close-circle {
  line-height: 0;
  position: absolute;
  top: 50%;
}

/*修改悬浮的关闭*/
.ivu-vueTime-div .ivu-input-suffix .ivu-icon-ios-time-outline {
  line-height: 0;
  position: absolute;
  top: 50%;
}
.timeId .ivu-input-wrapper{
    display: block;
}
</style>
<script>
import Vue from "vue";
import { locale, Page } from "view-design";
import cn from "view-design/dist/locale/zh-CN";
import en from "view-design/dist/locale/en-US";
Vue.component("Page", Page);
export default {
  name: "fvTime",
  props: ["primitives", "parentObject"],

  created() {
    this.changeLange();
    //窗口边框宽度。计算图元和组件位置时需要
    this.defaultTailoring = this.parentObject.defaultTailoring;
    //窗口大小
    this.windowSize = this.parentObject.windowSize;
    this.create();
    this.modelsPath = this.parentObject.modelsPath.slice(0);
    this.modelsPath.push(this.registerName);
    this.$store.registerModule(this.modelsPath, {
      state: {
        $: this
      }
    });
  },

  data() {
    return {
      isShow: true,
      isEnable: false,
      isShowTime: "",
      timeStyle: "",
      times: "",
      futureTime: {}
    };
  },
   watch: {
        //left改变
        x(newX,oldX){
            if(this.scaleObj){
                this.$el.style.left  = parseInt((newX * (this.scaleObj.sx + this.scaleObj.zoom)) + this.scaleObj.ox) + "px";
            }
        },
        //top改变
        y(newY,oldY){
            if(this.scaleObj){
                this.$el.style.top  = parseInt(((newY + this.scaleObj.titleHeight) * (this.scaleObj.sy + this.scaleObj.zoom)) + this.scaleObj.oy) + "px";
            }
        },
        //高度改变
        height(newHeight){
            if(this.scaleObj){
                this.$set(this.timeStyle,"height",parseInt(newHeight * (this.scaleObj.sx + this.scaleObj.zoom)) + "px");
                this.$set(this.timeStyle,"lineHeight",parseInt(newHeight * (this.scaleObj.sx + this.scaleObj.zoom)) + "px");
            }

        },
        //宽度改变
        width(newWidth){
            if(this.scaleObj){
                this.$set(this.timeStyle,"width",parseInt(newWidth * (this.scaleObj.sx + this.scaleObj.zoom)) + "px");
            }
        }
    },
  methods: {
    changeLange() {
      if (this.$store.state.system.$.languageName == "ch") {
        locale(cn);
      } else {
        locale(en);
      }
    },
    create() {
      this.mixin(this.primitives);
      this.windowsObject = this.$parent.$parent;
      this.workbench = this.windowsObject.workbench;
      //初始化位置 reDraw中
      this.timeStyle = {
        left: 0 + "px",
        top: 0 + "px",
        width: 0 + "px",
        height: 0 + "px"
      };
      this.enableStyle = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: "0px",
        backgroundColor: "#ccbfbf",
        opacity: "0.5"
      };
      //展示类型
      this.isShowTime = this.initType;
      if (this.currentTime) {
        this.times = new Date();
      } else {
        if (this.initType == 0) {
          this.times = this.initDate + " " + this.initTime;
        } else if (this.initType == 1) {
          this.times = this.initTime;
        } else if (this.initType == -1) {
          this.times = this.initDate;
        }
      }
      if (!this.timerDisabled) {
        //未来时间禁用
        this.futureTime = {
          disabledDate(date) {
            return date && date.valueOf() > Date.now();
          }
        };
      }
    },
    //混入属性
    mixin(src) {
      for (var key in src) {
        this[key] = src[key];
      }
    },
    /*
          参数：e 鼠标信息
               domScale 窗口放大、缩小、偏移等信息
          作用：鼠标事件调用函数，无必要可不进行任何处理
      */
    doFixedEvent(e, domScale) {},
    reDraw(scaleObj) {
      if(scaleObj.titleHeight != 0){
          var titleHeight = 0;
      }else{
          var titleHeight = this.y * this.frameScaleY;
      }
      
      let top = parseFloat(((this.y +titleHeight)* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy)
      let height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom))
      this.timeStyle = {
        left:parseInt(((this.x)* (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px",
        top:top-titleHeight+'px',
        width: parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px",
        height: height + "px",
        fontSize: 12 * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy + "px"
      };
      this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
        this.changeLange();
      });
    },
    onTimer() {
      if (this.isEnable) return;
    },
    /*
          参数：isShow 显示隐藏
          作用：设置组件整体显隐
      */
    Show(isShow) {
      this.isShow = isShow ? true : false;
    },
    /*
          参数：isEnable 是否可用
          作用：设置组件是否可用
      */
    Enable(isEnable) {
      this.isEnable = isEnable ? false : true;
    },
    onStartTimeChange(startTime, type) {},
    /*
          参数：UTC时间
          作用：UTC时间转化为本地时区时间
      */
    convertUTCTimeToLocalTime(UTCDateString) {
      if (!UTCDateString) {
        return "-";
      }

      function formatFunc(str) {
        //格式化显示
        return str > 9 ? str : "0" + str;
      }
      var date2 = new Date(UTCDateString); //这步是关键
      var year = date2.getFullYear();
      var mon = formatFunc(date2.getMonth() + 1);
      var day = formatFunc(date2.getDate());
      var hour = date2.getHours();
      // var noon = hour >= 12 ? 'PM' : 'AM';
      // hour = hour>=12?hour-12:hour;
      hour = formatFunc(hour);
      var min = formatFunc(date2.getMinutes());
      var second = formatFunc(date2.getSeconds());
      // var dateStr = year+'-'+mon+'-'+day+' '+noon +' '+hour+':'+min;
      var dateStr =
        year +
        "/" +
        mon +
        "/" +
        day +
        " " +
        hour +
        ":" +
        min +
        ":" +
        "" +
        second;
      return dateStr;
    },
    /*
          参数：返回时间类型（0为返回日期时间，1为返回时间,-1返回日期）
          作用：获取时间控件时间
      */
    GetTimeControl(timeType) {
      var timeStr = this.convertUTCTimeToLocalTime(this.times);
      if (timeType == 0) {
        return timeStr;
      } else if (timeType == 1) {
        return timeStr.substr(timeStr.indexOf(" ") + 1);
      } else if (timeType == -1) {
        return timeStr.substr(0, timeStr.indexOf(" "));
      } else {
        alert("输入参数无效");
      }
    },
    /**
     * 作用：获取时间控件时间
     * 返回值：为设置时间控件的毫秒数
     */
    GetTimeControlInt() {
      var timeStr = this.convertUTCTimeToLocalTime(this.times);
      return new Date(timeStr).getTime();
    },
    /*
          参数：0：日期，1：时间 
          作用：设置时间控件时间
      */
    SetTime(date, time) {
      if (time == undefined || time == "") {
        var tempTime = date;
        this.times = tempTime;
      } else {
        var tempTime = date + " " + time;
        this.times = tempTime;
      }
    },
    /**
     * 作用：设置时间控件时间
     * 参数：设置日期的毫秒
     */
    SetTimeInt(data) {
      var date = new Date(data);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      this.times =
        year +
        "/" +
        month +
        "/" +
        day +
        "  " +
        hour +
        ":" +
        minute +
        ":" +
        second;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/primitives/fvTime/fvTime.vue